import { apiGet, apiPut, apiPost } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import * as notifications from './notificationActions';

// Landlord Reference Verification
function displayLandlordReferenceVerification(response) {
  return {
    type: 'DISPLAY_LANDLORD_REFERENCE_VERIFICATION',
    landlord_reference_verification: response,
  };
}

function displaySuccessfulVerificationMessage() {
  return {
    type: 'SURVEY::DISPLAY_SUCCESSFUL_VERIFICATION_MESSAGE',
  };
}

export function displayLoader(shouldDisplay) {
  return {
    type: 'DISPLAY_LOADER',
    display: shouldDisplay,
  };
}

export function getLandlordReferenceVerification(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/landlord_references/verification/' + uuid)
        .done(response => {
          if (response.data.landlord_reference.verified) {
            dispatch(displayLoader(false));
            dispatch(displaySuccessfulVerificationMessage());
          } else {
            dispatch(displayLandlordReferenceVerification(response.data));
          }
        })
        .catch(error => {
          dispatch(displayLoader(false));
          console.error('request failed', error);
          browserHistory.push('/dashboard');
        }),
    });
  };
}

export function putLandlordReferenceVerification(uuid, data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.had_late_payments = data.had_late_payments.toLowerCase() === 'yes';
  data_clone.sent_notices = data.sent_notices.toLowerCase() === 'yes';
  data_clone.rent_amount_confirmed = data.rent_amount_confirmed.toLowerCase() === 'yes';
  data_clone.lived_for_confirmed = data.lived_for_confirmed.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(
        Auth.getApiUrl() + '/leads/landlord_references/verification/' + uuid,
        data_clone
      )
        .done(response => {
          dispatch(displaySuccessfulVerificationMessage());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

// Permission to Enter
export function getTenantPermissionToEnter(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/permission_for_entry/' + uuid)
        .done(response => {
          if (response.permission.verified) {
            dispatch(displayLoader(false));
            dispatch(displaySuccessfulVerificationMessage());
          } else {
            dispatch(displayMaintenanceSurveyVerification(response.permission));
          }
        })
        .catch(error => {
          dispatch(displayLoader(false));
          console.error('request failed', error);
          browserHistory.push('/dashboard');
        }),
    });
  };
}

// Personal Reference verification
function displayMaintenanceSurveyVerification(response) {
  return {
    type: 'DISPLAY_MAINTENANCE_SURVEY_VERIFICATION',
    maintenance_survey_verification: response,
  };
}

export function surveyVerification(surveyUUID, access_token) {
  return dispatch => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + `/landlords/surveys/${surveyUUID}/verify/${access_token}`,
        {
          access_token,
        }
      )
        .done(response => {
          dispatch(displayLoader(false));
          dispatch(displaySurvey(response));
        })
        .catch(error => {
          dispatch(displayLoader(false));
          dispatch(displayErrorVerificationMessage(error.responseJSON.verifySurveyTranslationCode));
          console.error('request failed', error);
        }),
    });
  };
}

function displayErrorVerificationMessage(surveyVerificationMessage) {
  return {
    type: 'SURVEY::DISPLAY_LANDLORD_VERIFICATION_MESSAGE',
    surveyVerificationMessage,
  };
}

function displaySurvey(surveyDetails) {
  return {
    type: 'SURVEY::DISPLAY_SURVEY',
    surveyTitle: surveyDetails.survey_title,
    surveyDescription: surveyDetails.description,
    surveyQuestions: surveyDetails.survey_questions,
    tenantFirstName: surveyDetails.tenant_first_name,
  };
}

export function maintenanceSurveyVerification(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/surveys/maintenance/verification/' + uuid)
        .done(response => {
          if (response.data.verified) {
            dispatch(displayLoader(false));
            dispatch(displaySuccessfulVerificationMessage());
          } else {
            dispatch(displayMaintenanceSurveyVerification(response.data));
          }
        })
        .catch(error => {
          dispatch(displayLoader(false));
          console.error('request failed', error);
          browserHistory.push('/dashboard');
        }),
    });
  };
}

export function submitSurvey(uuid, accessToken, data) {
  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/surveys/${uuid}/submission/${accessToken}`,
        data
      )
        .done(response => {
          dispatch(displaySuccessfulVerificationMessage());
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function submitMaintenanceSurvey(uuid, data) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/surveys/maintenance/' + uuid, data)
        .done(response => {
          dispatch(displaySuccessfulVerificationMessage());
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}
